<!-- components/EditForm.vue -->
<template>
  <div class="edit-form">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="同盟名称" prop="groupName" v-show="typePage == 'creatGroup'">
        <el-input v-model="form.groupName"></el-input>
      </el-form-item>
      <el-form-item label="邀请码" prop="joinCode" v-show="typePage == 'joinGroup'">
        <el-input v-model="form.joinCode"></el-input>
      </el-form-item>
      <div class="button-div">
        <el-button type="primary" @click="creatGroup" v-show="typePage == 'creatGroup'">创建</el-button>
        <el-button type="primary" @click="applyGroup" v-show="typePage == 'joinGroup'">申请</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
  name: 'GroupPageST',
  props: ['typePage'],
  data() {
    return {
      form: {
        "groupName": "",
        "joinCode": ""
      }, // 复制数据避免直接修改 props
      rules: {
          groupName: [
            { required: true, message: '请输入同盟名称', trigger: 'blur' },
            { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
          ],
          joinCode: [
            { required: true, message: '请输入同盟邀请码', trigger: 'blur' },
            { min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur' }
          ]
        }
    }
  },
  methods: {
    cleanForm() {
      this.form = {
        "groupName": "",
        "joinCode": ""
      }
    },
    close() {
      this.$emit('close');
    },
    async creatGroup() {
        try {
          // 自动带 Token，自动处理错误
          const res = await request.post('/CreatGroup', {
              groupName: this.form.groupName
          })
          
          // 调用创建同盟API
          this.$emit('save', {
              userID: res.response.userID,
              Department: res.response.Department,
              Position: res.response.Position,
              CodeGroup: res.response.CodeGroup,
              UserNumber: res.response.UserNumber,
              DepartmentID: res.response.DepartmentID
          });
          this.close();
        } catch (err) {
            this.initPage();
            console.error('VerifyTK error:', err);
            this.$messageX.xiaoxiti("e", "网络错误，请检查连接");
        }
    },
    async applyGroup() {
        try {
          // 自动带 Token，自动处理错误
          const res = await request.post('/JoinGroup', {
              CodeGroup: this.form.joinCode
          })
          
          this.$emit('join', {
              userID: res.response.userID,
              Department: res.response.Department,
              Position: res.response.Position,
              CodeGroup: res.response.CodeGroup,
              UserNumber: res.response.UserNumber,
              DepartmentID: res.response.DepartmentID
          });
          this.close();
        } catch (err) {
            this.initPage();
            console.error('VerifyTK error:', err);
            this.$messageX.xiaoxiti("e", "网络错误，请检查连接");
        }
    },
    initPage() {
      if (this.typePage == "creatGroup"){
            this.rules.joinCode[0].required = false;
            this.rules.groupName[0].required = true;
        }else if (this.typePage == "joinGroup"){
            this.rules.groupName[0].required = false;
            this.rules.joinCode[0].required = true;
        }else{
          console.log("控件传入值错误！");
          this.$messageX.xiaoxiti("e", "控件传入值错误！");

        }
    }
  },
  mounted() {
    this.initPage();
  },
  beforeUnmount() {
    
  },
}
</script>

<style scoped>
.edit-form input {
  display: block;
  margin-bottom: 10px;
  padding: 6px;
}

.button-div {
  margin-left: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 18px;
}

.yzm {
  width: 56%;
  height: 48px;
}

.captcha-image {
  height: 46px;
  width: 120px;
  border: 2px solid #ddd;
  border-left: none;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
}
</style>